<template>
  <div class="screen-list">
    <div style="margin-top: 4rem; background: white">
      <v-row class="pa-6" no-gutters>
        <v-col cols="6">
          <v-row no-gutters align="center">
            <v-col cols="5">
              <img src="/img/icons/icon-open-file.svg" width="30px" />
              <span class="px-3 font-20">จังหวัด</span>
            </v-col>
            <v-col cols="7">
              <v-autocomplete
                v-model="province"
                :items="BPprovince"
                item-text="PROVINCE_NAME"
                item-value="PROVINCE_ID"
                placeholder="ทั้งหมด"
                outlined
                hide-details
                hide-selected
                clearable
                @change="getBPDistrict(), getCustomer()"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters align="center">
            <v-col cols="4">
              <span class="px-3 font-20">อำเภอ</span>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                v-model="district"
                :items="BPDistrict"
                item-text="AMPHUR_NAME"
                item-value="AMPHUR_ID"
                placeholder="ทั้งหมด"
                outlined
                hide-details
                hide-selected
                clearable
                @change="getCustomer()"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <div class="pa-6">
        <v-autocomplete
          :items="dataCustomers"
          :loading="isLoading"
          :search-input.sync="search"
          hide-details
          hide-selected
          rounded
          placeholder="ค้นหาร้านค้า"
          outlined
          height="65"
          @click:clear="clearCustomer"
          clearable
          return-object
          @change="selectedCustomer"
          class="search-customer"
          item-value="customer_name"
          item-text="customer_name"
        >
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="blue-grey"
              class="white--text"
              v-on="on"
            >
              <img :src="item.customer_pic" class="profile-user" />
              <span v-text="item.customer_name" style="color: black"></span>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <img :src="item.customer_pic" class="profile-user" />
            <v-list-item-content>
              <v-list-item-title>{{ item.customer_name }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </div>
    </div>

    <!-- section : ข้อมูลร้าน -->
    <section v-if="viewCustomer != null">
      <div
        class="d-flex align-center px-6"
        style="border-bottom: 1px solid #c8c8c8"
      >
        <div>
          <v-avatar>
            <img :src="viewCustomer.customer_pic" alt="profile-picture" />
          </v-avatar>
        </div>
        <div class="px-4">
          <div>
            <span>{{ viewCustomer.customer_name || '-' }}</span>
          </div>
          <div class="d-flex py-2">
            <div>
              <small class="font-20">BP No. : </small>
              <small class="text-red font-20">{{
                viewCustomer.BPcode || '-'
              }}</small>
            </div>
            <div class="px-3">|</div>
            <div>
              <small class="font-20">BP Provine : </small>
              <small class="text-red font-20">{{
                viewCustomer.provinces || '-'
              }}</small>
            </div>
            <div class="px-3">|</div>
            <div>
              <small class="font-20">BP District : </small>
              <small class="text-red font-20">{{
                viewCustomer.amphur || '-'
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- section : price and stock -->
    <div class="container-stock">
      <div class="d-flex justify-content-between align-center">
        <div class="d-flex align-items-center">
          <img src="/img/icons/icon-note.svg" width="35px" />
          <span class="px-4 font-w-500 f-20">ราคาและปริมาณซื้อเข้า</span>
        </div>
        <div>
          <small class="f-20">Total : {{ form.total }} รายการ</small>
        </div>
      </div>

      <div class="d-flex align-center my-6" style="justify-content: end">
        <div class=" ">
          <img src="/img/icons/icon-warn.svg" width="35px" />
          <span class="px-4 font-w-400"
            >กรุณาคลิกปุ่มเพื่อเข้าหน้าเก็บราคาสินค้าอื่น ๆ
          </span>
        </div>

        <button
          type="button"
          class="bade-report"
          :class="[togglePriceOther ? 'pricestock-blue' : 'pricestock']"
          @click="togglePriceOther = !togglePriceOther"
        >
          {{ togglePriceOther ? 'เก็บราคาสินค้าปกติ' : 'เก็บราคาสินค้าอื่นๆ' }}
        </button>
      </div>

      <div class="d-flex pt-6" :class="[activeChipFilter ? '' : 'py-6']">
        <v-col cols="11" class="ma-0 pa-0">
          <v-text-field
            v-model="form.search"
            type="text"
            color="#a50200"
            height="70"
            outlined
            append-icon="icon-Search"
            class="radius-10"
            placeholder="ค้นหาสินค้า"
            v-on:keyup.enter="searchProduct"
            @click:append="searchProduct"
          />
        </v-col>

        <v-col v-show="!togglePriceOther" cols="1" class="ma-0 pa-0">
          <div class="card-icon-filter">
            <img
              src="img/icons_v2/icon-main-filter.png"
              width="35px"
              height="35px"
              alt="icon-filter"
              @click="drawerFilter = true"
            />
          </div>
        </v-col>
      </div>

      <ChipFilter
        v-if="activeChipFilter"
        :items="productFilter"
        :itemsBrand="brandFilter"
        @toggle="toggleChipFilter"
        @toggleBrand="toggleChipBrandFilter"
      />

      <!------------ table orgin  ------------>
      <section v-show="!togglePriceOther">
        <!-- thead -->
        <div class="card-thead">
          <div class="th" style="width: 5%">&nbsp;&nbsp;</div>
          <div class="th" style="width: 25%">
            <div class="th-sort">
              <span class="w-100">ชื่อสินค้า</span>
              <img
                :src="iconSort"
                class="icon-sort"
                @click="sortedString(table, 'name')"
              />
            </div>
          </div>
          <div class="th" style="width: 22%">
            <div class="th-sort position-relative">
              <div class="icon-attention">
                <img
                  :src="iconAttention"
                  width="22px"
                  height="22px"
                  @click="openToolTipt('in')"
                />
                <div v-show="tooltipt_in" class="tooltiptext">
                  <span class="f-20">ราคาซื้อเข้า (รวมVAT และค่าขนส่ง)</span>
                </div>
              </div>
              <span class="w-100">ราคาซื้อเข้า</span>
              <img
                :src="iconSort"
                class="icon-sort"
                @click="sortedNumber(table, 'wholesale_price')"
              />
            </div>
          </div>
          <div class="th" style="width: 22%">
            <div class="th-sort position-relative" style="margin: 0px 15px">
              <div class="icon-attention">
                <img
                  :src="iconAttention"
                  width="22px"
                  height="22px"
                  @click="openToolTipt('out')"
                />
                <div
                  v-show="tooltipt_out"
                  class="tooltiptext"
                  style="right: 9rem"
                >
                  <span class="f-20">ราคาขายออก (รวมVAT ไม่รวมค่าขนส่ง)</span>
                </div>
              </div>

              <span class="w-100">ราคาขายออก</span>
              <img
                :src="iconSort"
                class="icon-sort"
                @click="sortedNumber(table, 'retail_price')"
              />
            </div>
          </div>
          <div style="width: 20%">
            <div class="th-sort" style="margin: 0px 15px">
              <span class="w-100 text-center">ปริมาณซื้อเข้า <br />/เดือน</span>
              <img
                :src="iconSort"
                class="icon-sort"
                @click="sortedNumber(table, 'stock')"
              />
            </div>
          </div>
          <div
            class="text-center"
            style="width: 10%; border-left: 1px solid white"
          >
            <span>&nbsp;ㅤ</span>
          </div>
        </div>

        <!-- tbody -->
        <div
          class="overflow-y-auto mt-5"
          style="height: 700px; margin-bottom: 5rem"
          @scroll="onScrollTable"
        >
          <div
            v-for="(i, k) in table"
            :key="k"
            class="card-tbody"
            :class="{ 'bk-none': k % 2 }"
          >
            <div class="td px-1" style="width: 5%">{{ k + 1 }}.</div>
            <div class="td" style="width: 26%" @click="actionDialogPrice(i, k)">
              <div class="position-relative">
                <div class="text-overflows text-left">
                  <span>{{ i.name }}</span>
                </div>
              </div>
            </div>
            <!-- ราคาซื้อเข้า -->
            <div class="td td-colum" style="width: 23%">
              <v-text-field
                v-model="i.wholesale_price"
                type="number"
                suffix="฿"
                class="field-number centered-input"
                :class="
                  textStockActive({
                    middle_price_in: i.middle_price_in,
                    value: i.wholesale_price,
                    min: i.min_price_in,
                    max: i.max_price_in,
                    selected: i.status,
                  })
                "
                @keyup="keyupPrice(k)"
                @keypress="filterInput"
              />
            </div>
            <!-- ราคาขายออก -->
            <div class="td td-colum" style="width: 23%">
              <v-text-field
                v-model="i.retail_price"
                type="number"
                suffix="฿"
                class="field-number centered-input"
                @keyup="keyupPrice(k)"
                @keypress="filterInput"
              />
            </div>
            <div class="td td-colum" style="width: 18%">
              <v-text-field
                v-model="i.stock"
                type="number"
                :suffix="i.unit"
                class="field-number centered-input"
                @keyup="keyupPrice(k)"
                @keypress="filterInput"
              />
            </div>
            <div class="td pa-0" style="width: 5%">
              <img
                :src="[
                  i.status
                    ? 'img/icons_v2/icon-checked.png'
                    : 'img/icons_v2/icon-check.png',
                ]"
                width="30px"
                height="30px"
                @click="onSelectProduct(k)"
              />
            </div>

            <!-- message alert price min max -->
            <section
              v-if="i.middle_price_in !== 0 && i.status"
              class="message-alert"
            >
              <div :class="textStockActiveBox(i)">
                <div
                  v-show="i.status === true"
                  style="background: rgba(169, 24, 42, 0.12)"
                >
                  <img src="img/icons/alert-circle.svg" alt="icon" />
                  <span class="mx-2" style="color: #a9182a; font-size: 16px">
                    ราคาสินค้านี้ไม่อยู่ในระดับราคาตลาด
                  </span>
                </div>
              </div>
            </section>
          </div>

          <section v-if="isLoading" class="text-center pb-10">
            กำลังโหลด...
          </section>

          <section
            v-if="!isLoading && table.length === 0"
            class="text-center"
            style="padding-top: 5rem"
          >
            ไม่พบข้อมูล
          </section>
        </div>
      </section>
      <!------------ /table orgin  ------------>

      <!------------ table price other  ------------>
      <section v-show="togglePriceOther">
        <!-- thead -->
        <div class="card-thead">
          <div class="th" style="width: 24%">
            <div class="th-sort">
              <span class="w-100">ชื่อสินค้า</span>
              <img :src="iconSort" class="icon-sort" />
            </div>
          </div>
          <div class="th" style="width: 18%">
            <div class="th-sort position-relative">
              <div class="icon-attention">
                <img
                  :src="iconAttention"
                  width="22px"
                  height="22px"
                  @click="openToolTipt('in')"
                />
                <div v-show="tooltipt_in" class="tooltiptext">
                  <span class="f-20">ราคาซื้อเข้า (รวมVAT และค่าขนส่ง)</span>
                </div>
              </div>
              <span class="w-100">ราคาซื้อเข้า</span>
              <img :src="iconSort" class="icon-sort" />
            </div>
          </div>
          <div class="th" style="width: 18%">
            <div class="th-sort position-relative" style="margin: 0px 15px">
              <div class="icon-attention">
                <img
                  :src="iconAttention"
                  width="22px"
                  height="22px"
                  @click="openToolTipt('out')"
                />
                <div
                  v-show="tooltipt_out"
                  class="tooltiptext"
                  style="right: 9rem"
                >
                  <span class="f-20">ราคาขายออก (รวมVAT ไม่รวมค่าขนส่ง)</span>
                </div>
              </div>

              <span class="w-100">ราคาขายออก</span>
              <img :src="iconSort" class="icon-sort" />
            </div>
          </div>
          <div style="width: 18%">
            <div class="th-sort" style="margin: 0px 15px">
              <span class="w-100 text-center">ปริมาณซื้อเข้า <br />/เดือน</span>
              <img :src="iconSort" class="icon-sort" />
            </div>
          </div>
          <div
            class="text-center"
            style="width: 10%; border-left: 1px solid white"
          >
            <div class="th-sort" style="margin: 0px 15px">
              <span>หน่วย</span>
            </div>
          </div>
          <div
            class="text-center"
            style="width: 12%; border-left: 1px solid white"
          >
            <div class="th-sort" style="margin: 0px 15px">
              <span>การแก้ไข</span>
            </div>
          </div>
        </div>

        <!-- tbody -->
        <div v-if="itemProducts.length !== 0" class="scroll-other">
          <div
            v-for="(i, k) in itemProducts"
            :key="k"
            class="card-tbody"
            :class="{ 'bk-none': k % 2 }"
          >
            <div class="td" style="width: 24%">
              <div class="text-left">
                <span class="font-18 font-w-700">
                  {{ k + 1 }}. {{ i.name }}
                </span>
              </div>
              <div class="text-left" style="color: #a3a3a3">
                <span class="font-18">รุ่น : {{ i.model }}</span>
                <span class="font-18 px-1">แบรนด์ : {{ i.brand_name }}</span>
              </div>
            </div>
            <div class="td td-colum" style="width: 18%">
              <span class="font-18">{{ i.cost_price }} ฿</span>
            </div>
            <div class="td td-colum" style="width: 18%">
              <span class="font-18">{{ i.price }} ฿</span>
            </div>
            <div class="td td-colum" style="width: 18%">
              <span class="font-18">{{ i.stock }} ฿</span>
            </div>
            <div class="td pa-0 text-center" style="width: 10%">
              <span class="font-18">{{ i.unit }}</span>
            </div>
            <div class="td pa-0 text-center" style="width: 12%">
              <img
                src="/img/icons/icon-trash.svg"
                width="45px"
                class="px-1"
                @click="removeProduct(k)"
              />
              <img
                src="/img/icons/icon-pencil.svg"
                width="45px"
                class="px-1"
                @click="dialogEditProduct(i, k)"
              />
            </div>
          </div>
        </div>

        <!-- button product -->
        <div class="mt-12" style="margin-bottom: 7rem">
          <div v-if="itemProducts.length === 0" class="text-center">
            <div>
              <img src="img/icons/icon-empty.svg" />
            </div>
            <div class="py-4">กรุณาเพิ่มรายการสินค้า</div>
          </div>

          <button type="button" class="btn-plus-po" @click="actionAddProduct()">
            <v-icon color="#FF811C">mdi-plus</v-icon>
            เพิ่มรายการ
          </button>
        </div>
      </section>
      <!------------ /table price other  ------------>
    </div>

    <!-- dialog check price -->
    <v-row justify="center">
      <v-dialog
        v-model="dialogCheckPrice"
        scrollable
        transition="dialog-top-transition"
        max-width="1200px"
      >
        <v-card>
          <div class="container-comfirm">
            <div class="card-title">
              <div class="my-4">
                <img src="img/icons/icon-wraning.svg" alt="icon" />
                <span class="font-weight-bold font-24 px-3"
                  >กรุณาตรวจสอบความถูกต้อง</span
                >
              </div>

              <div class="text-right px-5 mt-4">
                <span
                  >จำนวนรายการสินค้าที่มีการเก็บราคา :
                  {{ countDataPrice }} รายการ</span
                >
              </div>

              <div
                style="
                  max-height: 400px;
                  overflow-x: hidden;
                  overflow-y: scroll;
                "
              >
                <table class="table w-100 table-separate2 px-5">
                  <thead>
                    <tr>
                      <th>ชื่อลูกค้า</th>
                      <th>ราคาซื้อเข้า</th>
                      <th>ราคาขายออก</th>
                      <th>ปริมาณต่อเดือน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in table" :key="index">
                    <tr v-if="item.status">
                      <td style="width: 30%">
                        {{ index + 1 }}. {{ item.name }}
                      </td>
                      <td style="width: 20%">{{ item.wholesale_price }}</td>
                      <td style="width: 20%">{{ item.retail_price }}</td>
                      <td style="width: 20%">{{ item.stock }}</td>
                      <td
                        style="width: 10%"
                        class="text-center"
                        @click="removeCheckList(index)"
                      >
                        <img src="img/icons/icon-trash2.svg" alt="icon" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="py-4 my-4">
                <button
                  type="button"
                  class="btn btn-m-cancel2 mx-2"
                  @click="dialogCheckPrice = false"
                >
                  กลับไปแก้ไขข้อมูล
                </button>
                <button
                  type="button"
                  class="btn btn-m-submit mx-2"
                  @click="saveForm"
                >
                  บันทึกราคา
                </button>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- dialog add product other. -->
    <v-row v-if="dialogAddProduct" justify="center">
      <v-dialog v-model="dialogAddProduct" width="650">
        <div class="dialog-price">
          <div class="content-header justify-center align-center">
            <img src="/img/icons/icon-appstore.svg" alt="icon-appstore" />
            <span class="font-weight-bold px-2" style="font-size: 20px"
              >เพิ่มรายการ</span
            >
          </div>

          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="form_product_other.name"
                :items="products"
                label="ชื่อสินค้า"
                item-text="name"
                item-value="id"
                clearable
                @input="inputComboProduct"
              />
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="form_product_other.model"
                :items="models"
                label="รุ่น"
                item-text="model"
                item-value="model"
                clearable
                @input="inputComboModel"
              />
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="form_product_other.brand_name"
                :items="brands"
                item-text="brand_name"
                item-value="brand_name"
                label="แบรนด์"
                clearable
                @input="inputComboBrand"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form_product_other.cost_price"
                type="number"
                label="ราคาซื้อเข้า"
                append-icon="mdi-currency-btc"
                class="add-product"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form_product_other.price"
                type="number"
                label="ราคาขายออก"
                append-icon="mdi-currency-btc"
                class="add-product"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form_product_other.stock"
                type="number"
                label="ปริมาณซื้อเข้า / เดือน"
                class="add-product"
              />
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model="form_product_other.unit"
                :items="units"
                item-text="unit"
                item-value="unit"
                label="หน่วย"
                clearable
                @input="inputComboUnit"
              />
            </v-col>
          </v-row>

          <v-row class="mx-8">
            <v-col cols="6">
              <button
                type="button"
                class="btn-cancel-po"
                @click="dialogAddProduct = false"
              >
                ยกเลิก
              </button>
            </v-col>

            <v-col cols="6">
              <button
                v-if="mode"
                type="button"
                class="btn-submit-po"
                @click="saveNewProduct()"
              >
                เพิ่ม
              </button>
              <button
                v-else
                type="button"
                class="btn-submit-po"
                @click="editNewProduct()"
              >
                บันทึก
              </button>
            </v-col>
          </v-row>

          <!-- dummy button -->
          <button
            ref="button_dummy"
            type="button"
            style="display: none"
          ></button>
        </div>
      </v-dialog>
    </v-row>

    <DialogPrice
      :dialog="dialogPrice"
      :item="itemProduct"
      :indexItem="indexProduct"
      @inputNumber="inputNumber"
      @close="dialogPrice = false"
    />

    <!-- section input autocomplate customer -->
    <template>
      <DialogCustomers
        :dialog="dlFormCustomer"
        :customerId="form.customer_id"
        :customerItem="listCustomer"
        @selected="selectedDialogCustomer"
        @close="dlFormCustomer = false"
      />
    </template>

    <!-- section button submit -->
    <div class="position-relative">
      <!-- button origin -->
      <div v-if="!togglePriceOther" class="footer-stock">
        <div class="m-3">
          <span>{{ productActive }} รายการ</span>
        </div>
        <div class="m-3">
          <v-btn class="btn-submit" :disabled="!actionSubmit" @click="saveCf()"
            >บันทึก</v-btn
          >
        </div>
      </div>

      <!-- button orher -->
      <div v-else class="footer-stock">
        <div class="m-3">
          <span>{{ itemProducts.length }} รายการ</span>
        </div>
        <div class="m-3">
          <v-btn
            class="btn-submit"
            :disabled="actionSaveProductOther"
            @click="saveProductOther()"
          >
            บันทึก
          </v-btn>
        </div>
      </div>
    </div>

    <!-- filter group, brand -->
    <SidebarFilter
      :drawer="drawerFilter"
      @toggleDrawer="toggleDrawer"
      @filter="filterProduct"
      @cancel="filterProductReset"
    />
  </div>
</template>

<script>
import iconSort from '../../public/img/icons_v2/icon-sort.png'
import iconAttention from '../../public/img/icons_v2/icon-main-attention.png'
import DialogPrice from '@/components/v2/stock/DialogPrice.vue'
import DialogCustomers from '@/components/v2/stock/DialogCustomers.vue'
import ChipFilter from '@/components/v2/stock/ChipFilter.vue'
import SidebarFilter from '@/components/v2/stock/SidebarFilter.vue'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    DialogPrice,
    DialogCustomers,
    ChipFilter,
    SidebarFilter,
  },

  data() {
    return {
      iconSort: iconSort,
      iconAttention: iconAttention,
      dataCustomers: [],
      listCustomer: [],
      search: '',
      isLoading: false,
      dialogPrice: false,
      dlFormCustomer: false,
      form: {
        customer_id:
          this.$store.getters['checkinout/getIsVisiting'] == null
            ? ''
            : this.$store.getters['checkinout/getIsVisiting'].customer_id,
        search: '',
        page: 1,
        limit: 25,
        totalpages: 0,
        total: 0,
        group_id: [],
        company_code: [],
      },
      orderBy: {
        name: false,
        retail_price: false,
        wholesale_price: false,
        stock: false,
      },
      table: [],
      loadMore: false,
      itemProduct: '',
      indexProduct: null,
      drawerFilter: false,
      productFilter: '',
      brandFilter: [],
      tooltipt_in: false,
      tooltipt_out: false,
      togglePriceOther: false,
      province: [],
      district: [],
      BPprovince: [],
      BPDistrict: [],
      viewCustomer: null,
      // section product other
      dialogAddProduct: false,
      mode: true, // true = insert, false = update
      form_product_other: {
        product_id: null,
        model: '',
        brand_name: '',
        name: '',
        cost_price: '',
        price: '',
        stock: '',
        unit: '',
      },
      products: [],
      models: [],
      brands: [],
      units: [],
      itemProducts: [],
      indexEdit: null,
      dialogCheckPrice: false,
      ipAddress: null,

      isLoading: false,
      hasMore: true,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      optionHeader(state) {
        return {
          Authorization: `Bearer ${state.auth.accessToken}`,
          'Content-Type': 'application/json',
        }
      },
    }),

    customerID() {
      return this.form.customer_id == 'ทั้งหมด' ? '' : this.form.customer_id
    },

    productActive() {
      var active = []
      const data = this.table
      data.map((item) => {
        if (item.status === true) {
          active.push(item)
        }
      })

      return active.length
    },

    actionSubmit() {
      var result = false
      this.table.forEach((element) => {
        if (element.status) {
          result = true
        }
      })

      return result
    },

    activeChipFilter() {
      if (
        [...this.form.group_id, ...this.form.company_code].length === 0 ||
        this.togglePriceOther === true
      ) {
        return false
      } else {
        return true
      }
    },

    actionSaveProductOther() {
      return this.itemProducts.length === 0 ? true : false
    },

    countDataPrice() {
      let count = 0
      for (const item of this.table) {
        if (item.status === true) {
          count++
        }
      }
      return count
    },
  },

  watch: {
    customerID() {
      this.resetForm()
      this.resetFilter()
      this.form.search = ''
      this.getProduct()
    },
  },

  methods: {
    ...mapActions({
      visitCustomers: 'checkinout/visitCustomers',
    }),

    searchProduct() {
      this.resetForm()
      this.getProduct()
    },

    resetForm() {
      this.form.page = 1
      this.form.limit = 25
      this.form.totalpages = 0
      this.form.total = 0
      this.table = []

      this.isLoading = false
      this.hasMore = true
    },

    resetFilter() {
      this.productFilter = []
      this.brandFilter = []
      this.form.group_id = []
      this.form.company_code = []
    },

    getCustomer() {
      const options = {
        url: `${this.$baseAPINew}/web/?act=list_customer`,
        method: 'POST',
        data: {
          user_id: this.user.id,
          province: this.province.length == 0 ? '' : this.province,
          amphur: this.district.length == 0 ? '' : this.district,
        },
      }
      this.$axios(options).then((res) => {
        this.dataCustomers = res.data
        this.listCustomer = res.data
      })
    },

    async getProduct() {
      try {
        if (this.isLoading || !this.hasMore) return
        this.isLoading = true

        const res = await this.$axios.post(
          `${this.$baseAPIControl}/priceandstock/detail`,
          this.form,
          { headers: this.optionHeader },
        )
        if (
          Array.isArray(res.data.items.list) &&
          res.data.items.list.length > 0
        ) {
          this.form.totalpages = res.data.items.page.total
          this.form.total = res.data.items.page.total_row
          this.table.push(...res.data.items.list)
          this.form.page++
          this.hasMore = true
        } else {
          this.hasMore = false
        }

        this.isLoading = false
      } catch (error) {
        console.error(error)
        this.table = []
        this.hasMore = false
        this.isLoading = false
      }
    },

    onScrollTable(event) {
      const target = event.target
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
        this.getProduct()
      }
    },

    getBPProvinces() {
      const options = {
        url: `${this.$baseAPIControl}/dropdown/provinces`,
        method: 'POST',
        data: { multi_region: '', search: '' },
        headers: this.optionHeader,
      }
      this.$axios(options).then((res) => {
        this.BPprovince = res.data.provinces
      })
    },

    getBPDistrict() {
      const options = {
        url: `${this.$baseAPIControl}/dropdown/amphur`,
        method: 'POST',
        data: { province: this.province, search: '' },
        headers: this.optionHeader,
      }
      this.$axios(options).then((res) => {
        this.BPDistrict = res.data.amphur
      })
    },

    actionDialogPrice(item, index) {
      this.indexProduct = index
      this.itemProduct = item
      this.dialogPrice = !this.dialogPrice
    },

    saveCf() {
      const customerId = this.form.customer_id
      if (customerId == 'ทั้งหมด' || customerId == null || customerId == '') {
        this.dlFormCustomer = true
      } else {
        this.dialogCheckPrice = true
      }
    },

    removeCheckList(index) {
      this.table[index].status = false
    },

    saveForm() {
      const data = this.table
      const dataArr = data
        .filter((item) => item.status)
        .map((item) => {
          const { product_id, retail_price, wholesale_price, stock } = item
          // กรณีราคาเกินระดับ flag = Y
          const out_price_flag =
            item.middle_price_in != 0 &&
            (parseFloat(wholesale_price) < parseFloat(item.min_price_in) ||
              parseFloat(wholesale_price) > parseFloat(item.max_price_in))
              ? 'Y'
              : ''

          return {
            product_id,
            retail_price,
            wholesale_price,
            stock,
            out_price_flag,
          }
        })

      var dataForm = {
        customer_id: this.form.customer_id,
        ip_user: this.ipAddress,
        items: dataArr,
      }

      const options = {
        url: `${this.$baseAPI}/priceandstock/recive`,
        method: 'POST',
        data: dataForm,
        headers: this.optionHeader,
      }

      this.$axios(options).then((res) => {
        if (res.data.ret.msg === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ',
            showConfirmButton: false,
            timer: 1500,
          })
          this.dialogCheckPrice = false
        } else {
          Swal.fire({
            icon: 'error',
            title: 'บันทึกข้อมูลไม่สำเร็จ',
            showConfirmButton: true,
            confirmButtonText: `ตกลง`,
            confirmButtonColor: '#A9182A',
          })
        }
      })
    },

    onSelectProduct(index) {
      const { wholesale_price, retail_price, stock } = this.table[index]
      if (wholesale_price != '' || retail_price != '' || stock != '') {
        const stateStatus = this.table[index].status
        this.table[index].status = !stateStatus
      }
    },

    inputNumber() {
      const customerId = this.form.customer_id
      if (customerId == 'ทั้งหมด' || customerId == null || customerId == '') {
        this.dlFormCustomer = true
      }
    },

    selectedDialogCustomer(obj) {
      this.dlFormCustomer = false
      this.form.customer_id = obj.customer_id
      this.viewCustomer = obj
    },

    toggleDrawer() {
      this.drawerFilter = false
    },

    filterProduct(itemGroup, itemBrand) {
      this.resetForm()
      this.productFilter = itemGroup
      this.brandFilter = itemBrand
      this.form.group_id = itemGroup
      this.form.company_code = itemBrand
      this.getProduct()
    },

    filterProductReset() {
      this.resetForm()
      this.resetFilter()
      this.getProduct()
    },

    toggleChipFilter(item) {
      const data = this.productFilter
      var check = false

      data.forEach((element, index) => {
        if (element.id == item.id) {
          check = true
          this.productFilter.splice(index, 1)
        }
      })

      if (!check) {
        this.productFilter.push(item)
      }

      this.resetForm()
      this.form.group_id = this.productFilter
      this.getProduct()
    },

    toggleChipBrandFilter(item) {
      const data = this.brandFilter
      var check = false

      data.forEach((element, index) => {
        if (element.id == item.id) {
          check = true
          this.brandFilter.splice(index, 1)
        }
      })

      if (!check) {
        this.brandFilter.push(item)
      }

      this.resetForm()
      this.form.company_code = this.brandFilter
      this.getProduct()
    },

    selectedCustomer(item) {
      console.log(item)
      if (item !== undefined) {
        this.form.customer_id = item.customer_id

        if (item.user_id !== '') {
          this.viewCustomer = item
        }
      }
    },

    clearCustomer() {
      this.form.customer_id = ''
      this.viewCustomer = null
    },

    openToolTipt(value) {
      if (value === 'in') {
        this.tooltipt_in = !this.tooltipt_in
      } else if (value === 'out') {
        this.tooltipt_out = !this.tooltipt_out
      }
    },

    // section : add product other
    inputComboProduct(v) {
      if (typeof v === 'object') {
        this.form_product_other.name = v === null ? v : v.name
        this.form_product_other.product_id = v === null ? v : Number(v.id)
      } else {
        this.form_product_other.name = v
        this.form_product_other.product_id = 0
      }
    },

    inputComboModel(v) {
      if (typeof v === 'object') {
        this.form_product_other.model = v === null ? v : v.model
      } else {
        this.form_product_other.model = v
      }
    },

    inputComboBrand(v) {
      if (typeof v === 'object') {
        this.form_product_other.brand_name = v === null ? v : v.brand_name
      } else {
        this.form_product_other.brand_name = v
      }
    },

    inputComboUnit(v) {
      if (typeof v === 'object') {
        this.form_product_other.unit = v === null ? v : v.unit
      } else {
        this.form_product_other.unit = v
      }
    },

    removeProduct(index) {
      Swal.fire({
        width: 700,
        title: `คุณต้องการลบรายการสินค้าหรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn-border-primary',
          cancelButton: 'btn-border-danger',
        },
      }).then((result) => {
        if (result.value) {
          const result = this.itemProducts.filter((i, key) => key !== index)
          this.itemProducts = result

          Swal.fire({
            icon: 'success',
            title: `ลบรายการสำเร็จ`,
            showConfirmButton: false,
            timer: 1500,
          })
        }
      })
    },

    dialogEditProduct(object, index) {
      this.dialogAddProduct = true
      this.mode = false
      this.form_product_other = {
        product_id: object.product_id,
        model: object.model,
        brand_name: object.brand_name,
        name: object.name,
        cost_price: object.cost_price,
        price: object.price,
        stock: object.stock,
        unit: object.unit,
      }
      this.indexEdit = index
    },

    resetFormAddProduct() {
      this.form_product_other = {
        product_id: null,
        model: '',
        brand_name: '',
        name: '',
        cost_price: '',
        price: '',
        stock: '',
        unit: '',
      }
      this.indexEdit = null
    },

    actionAddProduct() {
      this.dialogAddProduct = true
      this.mode = true
      this.resetFormAddProduct()
    },

    editNewProduct() {
      this.$refs.button_dummy.click()

      setTimeout(() => {
        this.dialogAddProduct = false
        this.itemProducts[this.indexEdit].product_id =
          this.form_product_other.product_id
        this.itemProducts[this.indexEdit].model = this.form_product_other.model
        this.itemProducts[this.indexEdit].brand_name =
          this.form_product_other.brand_name
        this.itemProducts[this.indexEdit].name = this.form_product_other.name
        this.itemProducts[this.indexEdit].cost_price =
          this.form_product_other.cost_price
        this.itemProducts[this.indexEdit].price = this.form_product_other.price
        this.itemProducts[this.indexEdit].stock = this.form_product_other.stock
        this.itemProducts[this.indexEdit].unit = this.form_product_other.unit
      }, 50)

      setTimeout(() => {
        this.resetFormAddProduct()
      }, 500)
    },

    saveNewProduct() {
      this.$refs.button_dummy.click()

      setTimeout(() => {
        this.dialogAddProduct = false
        this.itemProducts.push(this.form_product_other)
      }, 50)

      setTimeout(() => {
        this.resetFormAddProduct()
      }, 500)
    },

    saveProductOther() {
      const options = {
        url: `${this.$baseAPIControl}/product/productOtherInsert`,
        method: 'POST',
        data: {
          customer_id: this.form.customer_id,
          product: this.itemProducts,
        },
        headers: this.optionHeader,
      }

      const customerId = this.form.customer_id
      if (customerId == 'ทั้งหมด' || customerId == null || customerId == '') {
        this.dlFormCustomer = true
      } else {
        this.dlFormCustomer = false
        this.$axios(options).then((res) => {
          if (res.status == 200) {
            Swal.fire({
              icon: 'success',
              title: 'บันทึกเก็บราคาสินค้าอื่นๆ สำเร็จ',
              showConfirmButton: false,
              timer: 1500,
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'บันทึกเก็บราคาสินค้าอื่นๆ ไม่สำเร็จ',
              showConfirmButton: true,
              confirmButtonText: `ตกลง`,
              confirmButtonColor: '#A9182A',
            })
          }
        })
      }
    },

    renderOption() {
      const optionsProducts = {
        url: `${this.$baseAPIControl}/product/productOtherList`,
        method: 'POST',
        data: { customer_id: this.form.customer_id, search: '' },
        headers: this.optionHeader,
      }

      const optionsMmodel = {
        url: `${this.$baseAPIControl}/product/productOtherModel`,
        method: 'GET',
        headers: this.optionHeader,
      }

      const optionsBrand = {
        url: `${this.$baseAPIControl}/product/productOtherBrand`,
        method: 'GET',
        headers: this.optionHeader,
      }

      const optionsUnit = {
        url: `${this.$baseAPIControl}/product/productOtherUnit`,
        method: 'GET',
        headers: this.optionHeader,
      }

      this.$axios(optionsProducts).then((res) => {
        this.products = res.data.items
      })

      this.$axios(optionsMmodel).then((res) => {
        this.models = res.data.items
      })

      this.$axios(optionsBrand).then((res) => {
        this.brands = res.data.items
      })

      this.$axios(optionsUnit).then((res) => {
        this.units = res.data.items
      })
    },

    textStockActive({ middle_price_in, value, min, max, selected }) {
      if (middle_price_in != 0 && selected) {
        if (
          parseFloat(value) < parseFloat(min) ||
          parseFloat(value) > parseFloat(max)
        ) {
          return 'text-stock-red'
        }
      }
    },

    textStockActiveBox(i) {
      if (i.middle_price_in == 0) {
        return 'd-none'
      } else {
        if (
          parseFloat(i.wholesale_price) < parseFloat(i.min_price_in) ||
          parseFloat(i.wholesale_price) > parseFloat(i.max_price_in)
        ) {
          return 'd-block'
        } else {
          return 'd-none'
        }
      }
    },

    keyupPrice(index) {
      const { wholesale_price, retail_price, stock } = this.table[index]
      if (wholesale_price == '' || retail_price == '' || stock == '') {
        this.table[index].status = false
      }
    },

    filterInput(inputEvent) {
      if (inputEvent.key == '-') {
        inputEvent.preventDefault()
      }
      return true
    },

    checkIP() {
      fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          this.ipAddress = data.ip
        })
    },
  },

  created() {
    this.renderOption()
  },

  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch('setTitle', 'เก็บราคา')
      this.checkIP()
    })

    this.getBPProvinces()
    this.getCustomer()
    this.visitCustomers({ user_id: this.user.id })

    const queryPath = this.$route.query.customer_id
    if (queryPath != undefined || queryPath != null) {
      this.form.customer_id = queryPath
    }

    this.getProduct()
  },
}
</script>

<style lang="scss" scoped>
.profile-user {
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin-right: 14px;
}

.container-stock {
  background: #ffffff;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%);
  padding: 25px;
}

.radius-10 {
  border-radius: 10px;
}

.card-thead {
  display: flex;
  align-items: center;
  background: #444444;
  border-radius: 9px;
  color: white;
  font-weight: bold;
  width: 100%;
  height: 90px;
  padding: 0px;
  margin: -20px 0px;

  & .th {
    text-align: center;
    border-right: 1px solid white;
  }
}

.card-tbody {
  position: relative;
  background: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 15px 0px;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 45px;

  & .td {
    text-align: center;
    padding: 15px;
  }
  & .td-colum {
    padding: 0px 25px;
  }
  &.bk-none {
    background: #eaeaea;
  }
}

.scroll {
  margin: 20px 0px;
  max-height: 740px;
  height: 740px;
  overflow: scroll;
  &.action {
    height: 645px !important;
  }
}

.scroll-other {
  margin: 20px 0px;
  max-height: 740px;
  overflow: scroll;
  &.action {
    height: 645px !important;
  }
}

.text-overflows {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.btn-submit {
  border: none;
  background: #a50200 !important;
  color: white;
  font-weight: bold;
  padding: 10px 0px;
}

.footer-stock {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.th-sort {
  display: flex;
  align-items: center;
  margin: 0 20px;
  justify-content: space-between;
  font-size: 18px !important;
  span {
    font-size: 18px !important;
  }
}

.icon-sort {
  width: 8px;
  height: 14px;
}

.bk-shadow {
  box-shadow:
    0 -2px 16px 0 rgba(0, 0, 0, 0.05),
    0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

* {
  scrollbar-width: thin;
}

*::-webkit-scrollbar {
  width: 5px;
}

*::-webkit-scrollbar-thumb {
  border-radius: 5px;
}

.item-attention {
  position: absolute;
  right: -17%;
  top: 10%;
}

.tooltiptext {
  width: 300px;
  background-color: #ffffff;
  color: black;
  text-align: center;
  border-radius: 9px;
  padding: 10px;
  position: absolute;
  bottom: 150%;
  right: 8rem;
  z-index: 100;
  box-shadow:
    rgb(136 165 191 / 48%) 4px 5px 16px 0px,
    rgb(255 255 255 / 80%) -6px -2px 16px 0px;
  opacity: 1;
  transition: 1s;
  font-size: 20px;
}

.tooltiptext::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 3%;
  margin-left: -7px;
  border-width: 7px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.footer-stock {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px !important;
  padding: 10px 0px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
}

.card-icon-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
}

.btn-tags-filter {
  border: 1px solid #a50200;
  border-radius: 9px;
  background-color: #fff1f1;
  padding: 10px 15px;
  color: #a50200;
}

.btn-price-other {
  background: #9e9e9e;
  padding: 10px 20px;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  &.active {
    background: #ff811c;
  }
}

.btn-plus-po {
  background: #ffffff;
  border: 2px dashed #ff811c;
  border-radius: 8px;
  width: 100%;
  color: #ff811c;
  font-weight: 500;
  height: 60px;
}

.dialog-price {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 40px 35px;
}

.content-header {
  display: flex;
}

.content-field {
  width: 100%;
  padding: 0px 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 38vh;
  max-height: 38vh;
}

.btn-cancel-po {
  height: 60px;
  background: #ffffff;
  box-shadow: 5px 5px 18px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  width: 100%;
  border: 1px solid #a9182a;
  color: #a9182a;
  font-weight: 500;
}
.btn-submit-po {
  height: 60px;
  background: linear-gradient(270deg, #a9182a 0%, #d70a0a 100%);
  box-shadow: 5px 5px 18px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  width: 100%;
  color: white;
  font-weight: 500;
}

.btn-add-priceother {
  width: 100%;
  background: #ffffff;
  border: 1px dashed #ff811c;
  box-shadow: 0px 1px 4px rgba(74, 144, 226, 0.22);
  border-radius: 8px;
  height: 45px;
  color: #ff811c;
  font-size: 16px !important;
  &:hover {
    background: #f9f9f9;
  }
}

.message-alert {
  position: absolute;
  bottom: 15px;
  width: 97%;
  border-radius: 4px;
  padding: 3px 15px;
  // background: rgba(169, 24, 42, 0.12);
  text-align: right;
  margin: auto;
}

.container-comfirm {
  justify-content: center;
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.card-title {
  margin: 20px;
}

.btn-m-cancel2 {
  font-family: Prompt;
  border: 1px solid #a60015;
  width: 225px;
  box-shadow: 5px 5px 18px 0 rgb(0 0 0 / 15%);
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  color: #b41421 !important;
  padding: 10px;
}
.btn-m-submit {
  font-family: Prompt;
  border: none;
  width: 225px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff !important;
  background: linear-gradient(to left, #a9182a, #d70a0a);
  box-shadow: 5px 5px 18px 0 rgb(0 0 0 / 15%);
  padding: 10px;
}

// origin
table.table-separate2 {
  border-collapse: separate;
  border-spacing: 0 15px;
}

table.table-separate2 th {
  background-color: #505d6f;
  color: #ffffff;
  // font-size: 14px;
  padding: 8px;
  vertical-align: middle;
  border: 0px solid #aeaeae;
  border-right: none;
  border-left: none;
}

table.table-separate2 th:first-of-type {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-left: 1px solid #aeaeae;
}

table.table-separate2 th:last-of-type {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-right: 1px solid #aeaeae;
}

table.table-separate2 tr {
  background: #ffffff;
  border-radius: 8px 0px 0px 8px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

table.table-separate2 td:first-of-type {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

table.table-separate2 td:last-of-type {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.bade-report {
  box-shadow: 5px 5px 18px 0 var(--black-8);
  color: white !important;
  font-weight: 700;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 10px 20px;
  border-radius: 8px;

  &.pricestock {
    background: #ff811c;
    box-shadow: 5px 5px 20px 0 rgb(0 0 0 / 15%) !important;
  }
  &.pricestock-outline {
    background: white !important;
    color: #ff811c !important;
    border: 1px solid #ff811c !important;
    box-shadow: 5px 5px 20px 0 rgb(0 0 0 / 15%) !important;
  }

  &.pricestock-blue {
    background: blue !important;
    color: white !important;
    border: 1px solid white !important;
    box-shadow: 5px 5px 20px 0 rgb(0 0 0 / 15%) !important;
  }
}
</style>

<style>
.add-product input {
  padding: 0px !important;
}

.search-customer input {
  padding: 0px 20px !important;
}
</style>
